import { ReactElement, useState } from "react";
import SelectedQuoteRevisionIdContext from "./SelectedQuoteRevisionIdContext";

export function SelectedQuoteRevisionIdProvider({
  children,
}: {
  children: ReactElement;
}) {
  const [selectedQuoteRevisionId, setSelectedQuoteRevisionId] = useState("");

  return (
    <SelectedQuoteRevisionIdContext.Provider
      value={{
        selectedQuoteRevisionId,
        setSelectedQuoteRevisionId,
      }}
    >
      {children}
    </SelectedQuoteRevisionIdContext.Provider>
  );
}
